import React from 'react';

interface InfoIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const Info: React.FC<InfoIconProps> = ({ 
  className = '',
  size = 24,
  color = '#3994FF' }) => (
  <svg className={className} width={size} 
    height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C17.5 2 22 6.5 22 12C22 
    17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 
    12 2ZM10.5801 11.5C10.3039 11.5 10.0801 11.7239 10.0801 12V12.5C10.0801 
    12.7761 10.3039 13 10.5801 13H11.0801V15H10.5801C10.3039 15 10.0801 15.2239 
    10.0801 15.5V16C10.0801 16.2761 10.3039 16.5 10.5801 16.5H13.5801C13.8562 
    16.4999 14.0801 16.2761 14.0801 16V15.5C14.0801 15.2239 13.8562 15.0001 13.5801 
    15H13.0801V11.75C13.0801 11.612 12.9681 11.5001 12.8301 11.5H10.5801ZM12.0801 
    7.5C11.2517 7.5 10.5801 8.17157 10.5801 9C10.5801 9.82843 11.2517 10.5 12.0801 
    10.5C12.9084 10.4999 13.5801 9.82839 13.5801 9C13.5801 8.17161 12.9084 7.50007 12.0801 7.5Z" fill={color} />
  </svg>
);

export default Info;
